<template>
  <div class="pc-course">
    <BreadCrumb :data="breadcrumb" :title="'作品列表管理'" />
    <StatisticalPanel
      :whichModule="'works'"
      :data="overallData"
    ></StatisticalPanel>
    <ModuleClassfication
      :title="titles"
      class="pc-Works-tab"
      @addTopic="addTopic"
      @updateTopic="updateTopic"
      @deleteTopic="deleteTopic"
    />
    <WorksTable />
  </div>
</template>

<script>
import BreadCrumb from "../../componentSet/BreadCrumb";
import ModuleClassfication from "../../componentSet/ModuleClassfication";
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel";
import WorksTable from "./component/WorksTable";
import {
  getWorksCount_Api,
  worksClassification_Api,
  worksCompetitionClassification_Api,
  getWorksClassification_Api,
  updateWorksClassification_Api,
  deleteWorksClassification_Api,
  getWorksCompetitionClassification_Api,
  updateWorksCompetitionClassification_Api,
  deleteWorksCompetitionClassification_Api,
} from "../../../apis/exhibition.api";
export default {
  data() {
    return {
      overallData: {
        title: "作品数据",
        count: [{ name: "作品数量", count: null }],
      },
      titles: {
        module: "作品",
        class: [
          { name: "works_classification", subTitles: [] },
          { name: "works_competition_classification", subTitles: [] },
        ],
      },
    };
  },
  components: {
    BreadCrumb,
    WorksTable,
    StatisticalPanel,
    ModuleClassfication,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "作品列表", link: "/admin/worksList" },
      ];
    },
  },
  mounted() {
    getWorksCount_Api().then((res) => {
      console.log(res);
      this.$set(this.overallData.count[0], "count", res.count);
    });
    this.TitleSearch();
    this.SubjectSearch();
  },
  methods: {
    updateTopic(topic, callback) {
      if (topic.type == "works_classification") {
        updateWorksClassification_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          classification_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.TitleSearch();
        });
      } else if (topic.type == "works_competition_classification") {
        updateWorksCompetitionClassification_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          classification_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.SubjectSearch();
        });
      }
    },
    addTopic(topic, callback) {
      console.log(topic);
      if (topic.type == "works_classification") {
        getWorksClassification_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          status: topic.status,
        }).then(() => {
          callback();
          this.TitleSearch();
        });
      } else if (topic.type == "works_competition_classification") {
        getWorksCompetitionClassification_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          status: topic.status,
        }).then(() => {
          callback();
          this.SubjectSearch();
        });
      }
    },
    deleteTopic(topic, callback) {
      if (topic.type == "works_classification") {
        deleteWorksClassification_Api({
          competition_id: topic.id,
        }).then(() => {
          callback();
          this.TitleSearch();
        });
      } else if (topic.type == "works_competition_classification") {
        deleteWorksCompetitionClassification_Api({
          competition_id: topic.id,
        }).then(() => {
          callback();
          this.SubjectSearch();
        });
      }
    },
    TitleSearch() {
      worksClassification_Api().then((res) => {
        this.$set(this.titles.class[0], "subTitles", res.data);
        console.log(this.titles);
        console.log(res.data);
      });
    },
    SubjectSearch() {
      worksCompetitionClassification_Api().then((res) => {
        console.log(res);
        this.$set(this.titles.class[1], "subTitles", res.data);
        console.log(this.titles);
        console.log(res.data);
      });
    },
  },
};
</script>



<style lang="scss"  scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/exhibition/WorksList.vue